import React, { Component } from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

export default class BooleanColumnEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value && props.value === "1" ? "0" : "1",
      initialValue: props.value && props.value === "1" ? "1" : "0",
    };
    this.arrowKeyNavigation = this.arrowKeyNavigation.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleChange = () => {
    var value = this.state.value === "1" ? "0" : "1";
    this.props.onChange(value);
    this.setState({ value: value }, () => {
      this.refs.input.focus();
    });
  };

  componentDidMount() {
    this.refs.container.addEventListener("keydown", this.arrowKeyNavigation);
    this.focus();
    if (this.state.initialValue !== this.state.value) {
      this.props.onChange(this.state.value);
    }
  }

  componentWillUnmount() {
    this.refs.container.removeEventListener("keydown", this.arrowKeyNavigation);
  }

  focusNextCell = (rowIndex, colId) => {
    this.props.api.clearRangeSelection();
    this.props.api.stopEditing();
    this.props.api.setFocusedCell(rowIndex, colId);
  };

  getColIds = () => {
    var nextColId = "",
      prevColId = "",
      columnDefs = this.props?.columnApi?.columnController?.columnDefs;
    for (let i = 0; i < columnDefs.length; i++) {
      if (columnDefs[i]["colId"] === this.props.colDef.colId) {
        nextColId =
          columnDefs[i + 1 === columnDefs.length - 1 ? i : i + 1]["colId"];
        prevColId = columnDefs[i - 1 < 0 ? i : i - 1]["colId"];
        break;
      }
    }
    return { nextColId: nextColId, prevColId: prevColId };
  };

  arrowKeyNavigation = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if ([13].indexOf(event.keyCode) > -1) {
      this.handleChange();
    } else {
      var { nextColId, prevColId } = this.getColIds();
      if ([37].indexOf(event.keyCode) > -1) {
        this.focusNextCell(this.props.rowIndex, prevColId);
      }
      if ([38].indexOf(event.keyCode) > -1)
        this.focusNextCell(
          this.props.rowIndex === 0 ? 0 : this.props.rowIndex - 1,
          this.props.column.colId
        );
      if ([39].indexOf(event.keyCode) > -1) {
        this.focusNextCell(this.props.rowIndex, nextColId);
      }
      if ([40].indexOf(event.keyCode) > -1)
        this.focusNextCell(
          this.props.rowIndex + 2 < this.props.context.props.store.data.length
            ? this.props.rowIndex + 1
            : this.props.rowIndex,
          this.props.column.colId
        );
    }
  };

  handleClickOutside() {
    this.props.api.stopEditing(false);
  }

  getValue() {
    return this.state.value;
  }

  isPopup() {
    return false;
  }

  focus() {
    window.setTimeout(() => {
      if (this?.refs?.input) this.refs.input.focus();
    }, 50);
  }

  render() {
    return (
      <ClickAwayListener onClickAway={this.handleClickOutside}>
        <div>
          <div
            ref="container"
            className="checkboxContainerMDB booleanRenderer booleanEditor"
            onClick={(e) => {
              this.handleChange();
            }}
          >
            <div
              className="custom-control custom-checkbox"
              style={{
                width: Number(this.props.colDef.width) - 10,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <input
                ref="input"
                type="checkbox"
                className="custom-control-input"
                id="defaultChecked"
                onChange={() => {}}
                checked={this.state.value === "1" ? true : false}
              />
              <label className="custom-control-label boolean-checkbox checkbox-pointer"></label>
            </div>
          </div>
        </div>
      </ClickAwayListener>
    );
  }
}
